import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../afterTimeout.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function animateOut(_this__u8e3s4, transition, done) {
  done = done === VOID ? null : done;
  var keyframeName = _this__u8e3s4.pc().qb3_1.ab2(transition);
  var transitionTime = _this__u8e3s4.mba().vb0_1;
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.vb5_1;
  var tmp0_safe_receiver = this_0.xb3_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).style.animation = keyframeName + '-exit ' + Duration__toString_impl_8d916b(transitionTime) + ' forwards';
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.wb3_1.v((it) => {
      (it instanceof HTMLElement ? it : THROW_CCE()).style.animation = keyframeName + '-exit ' + Duration__toString_impl_8d916b(transitionTime) + ' forwards';
      return Unit_instance;
    });
  }
  if (done == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    afterTimeout(_this__u8e3s4, _Duration___get_inWholeMilliseconds__impl__msfiry(transitionTime), done);
  }
}
function animateIn(_this__u8e3s4, transition, done) {
  done = done === VOID ? null : done;
  var keyframeName = _this__u8e3s4.pc().qb3_1.ab2(transition);
  var transitionTime = _this__u8e3s4.mba().vb0_1;
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.vb5_1;
  var tmp0_safe_receiver = this_0.xb3_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).style.animation = keyframeName + '-enter ' + Duration__toString_impl_8d916b(transitionTime) + ' forwards';
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.wb3_1.v((it) => {
      (it instanceof HTMLElement ? it : THROW_CCE()).style.animation = keyframeName + '-enter ' + Duration__toString_impl_8d916b(transitionTime) + ' forwards';
      return Unit_instance;
    });
  }
  if (done == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    afterTimeout(_this__u8e3s4, _Duration___get_inWholeMilliseconds__impl__msfiry(transitionTime), done);
  }
}
//region block: exports
export {
  animateIn as animateIn1nlg63kph14n6,
  animateOut as animateOut3n4hfswesreuc,
};
//endregion

//# sourceMappingURL=animations.js.mjs.map
